import styled from 'styled-components';

import { cBC44FF } from '#/colors';

const ExternalLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener',
})`
  color: ${cBC44FF};
`;

export default ExternalLink;
